export default function (props: any) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="23" height="20" viewBox="0 0 23 20" fill="none" {...props}>
            <g clipPath="url(#clip0_41_3260)">
                <mask id="mask0_41_3260" maskUnits="userSpaceOnUse" x="0" y="0" width="23" height="20">
                    <path d="M22.1287 0H0.676514V20H22.1287V0Z" fill="white" />
                </mask>
                <g mask="url(#mask0_41_3260)">
                    <path
                        d="M19.4463 12.1665C19.4461 12.5936 19.2579 13.0032 18.9228 13.3053C18.5877 13.6074 18.1332 13.7772 17.6593 13.7776H6.93288L3.35742 17V4.11122C3.35778 3.68401 3.54625 3.27434 3.88144 2.97226C4.21663 2.67018 4.67114 2.50032 5.14517 2.5H17.6593C17.894 2.5 18.1265 2.54172 18.3433 2.6227C18.5602 2.70367 18.7572 2.82234 18.9231 2.97196C19.0891 3.12158 19.2207 3.29919 19.3105 3.49466C19.4003 3.69014 19.4464 3.89967 19.4463 4.11122V12.1665Z"
                        stroke={props.bg ? props.bg : '#2F363D'}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </g>
                <ellipse cx="7.11216" cy="8" rx="1.07261" ry="1" fill={props.bg ? props.bg : '#2F363D'} />
                <ellipse cx="11.4027" cy="8" rx="1.07261" ry="1" fill={props.bg ? props.bg : '#2F363D'} />
                <ellipse cx="15.693" cy="8" rx="1.07261" ry="1" fill={props.bg ? props.bg : '#2F363D'} />
            </g>
            <defs>
                <clipPath id="clip0_41_3260">
                    <rect width="21.4521" height="20" fill="white" transform="translate(0.676514)" />
                </clipPath>
            </defs>
        </svg>
    );
}
